
export default {
  SET_LABOR_TEMPLATES(state, data) {
    state.laborTemplates = data;
  },
}
